import styled from 'styled-components'
import { SIZES } from '../../../../../constants'

export default styled.div`
  background: #fff;
  border: 1px solid #ccc;
  border-top: 0;
  left: 0;
  position: absolute;
  top: 40px;
  width: 100%;
  z-index: 100;
  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    max-width: unset;
  }
`
